export default __webpack_public_path__ + "static/media/login-background@2x.e5c7684b.jpg";